module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/c095368fe13af007098add0337226c01.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Epic/Epic2.svg
// module id = RYvy
// module chunks = 1